(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

	// const upsellSwiper = new Swiper(".drawer-upsell-swiper", {
	// 	slidesPerView: 1,
	// 	spaceBetween: 20,
	// 	loop: false,
	// 	navigation: {
	// 		nextEl: ".drawer_upsell_swiper_button_next",
	// 		prevEl: ".drawer_upsell_swiper_button_prev",
	// 	},
	// 	pagination: {
	// 		el: ".swiper-pagination",
	// 		clickable: true,
	// 	},
	// });

	// var upsellSwiper = new Swiper(".drawer-upsell-swiper", {
	// 	slidesPerView: 2,
	// 	spaceBetween: 20,
	// 	loop: true,
	// 	navigation: {
	// 		nextEl: ".drawer_upsell_swiper_button_next",
	// 		prevEl: ".drawer_upsell_swiper_button_prev",
	// 	},
	// 	pagination: {
	// 		el: ".swiper-pagination",
	// 		clickable: true,
	// 	},
	// });
	
})();